import React from 'react';
import Icons from '../../../components/icons';
import NavigationItem from './NavigationItem';
import { NavigationMenuProps } from '../types';
import etherLogoIcon from '../../../assets/images/ether.png';
import etherLogo from '../../../assets/images/ether_logo.png';
import {
  NavigationDrawer,
  NavigationItemList,
  StyledEtherLogo,
  SidebarFooter,
  drawerWidth,
  StyledDivider,
  NavigationHeader,
  NavigationContainer,
  FloatingPinButton,
  IconContainer
} from './styled';
import { useNavigation } from '../constants/navigation';

const NavigationMenu = ({
  open,
  openDropdown,
  handleDropdownToggle,
  selectedPage,
  setSelectedPage,
  onMouseEnter,
  onMouseLeave,
  isPinned,
  handleTogglePinned
}: NavigationMenuProps) => {
  const CaretLeft = Icons.CaretLeftWhite;
  const CaretRight = Icons.CaretRightWhite;
  const NAVIGATION = useNavigation();
  return (
    <>
      <NavigationDrawer
        open={open}
        drawerWidth={drawerWidth}
        variant='permanent'
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <NavigationItemList>
          <NavigationHeader>
            {open ? (
              <StyledEtherLogo src={String(etherLogo)} alt='ether' />
            ) : (
              <StyledEtherLogo src={String(etherLogoIcon)} alt='ether' />
            )}
            <StyledDivider />
          </NavigationHeader>
          <NavigationContainer>
            {NAVIGATION.map((navigationItem) => (
              <NavigationItem
                key={navigationItem.title}
                navigationItem={navigationItem}
                open={open}
                openDropdown={openDropdown}
                handleDropdownToggle={handleDropdownToggle}
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage}
              />
            ))}
          </NavigationContainer>
        </NavigationItemList>
        {open && (
          <FloatingPinButton onClick={handleTogglePinned} $isPinned={isPinned}>
            <IconContainer $isPinned={isPinned}>
              <CaretLeft />
              <CaretRight />
            </IconContainer>
          </FloatingPinButton>
        )}
        {open ? (
          <SidebarFooter variant='caption' open={open}>
            © Ether. All Rights Reserved.
          </SidebarFooter>
        ) : (
          <SidebarFooter variant='caption' open={open}>
            © Ether. All&nbsp;Rights Reserved.
          </SidebarFooter>
        )}
      </NavigationDrawer>
    </>
  );
};

export default NavigationMenu;
